import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "9.75", stroke: "black", strokeWidth: "1.5", fill: "white" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.249 8.78147L16.7188 8.25122L10.124 14.8456L7.27927 12.0012L6.74902 12.5315L10.124 15.9065L17.249 8.78147Z", stroke: "black", strokeWidth: "0.75" })), 'CheckCircleOutlined');
